<template>
	<div class="banner div_home_toutiao">
	  <div class="w1200">
	    <div class="subTop">
	      <em>Headlines News</em>
	      <span>头条要闻</span>
	      <router-link to="/toutiao" class="more" @click.native="$track([['pagetype','首页-头条要闻-更多-点击']])">更多</router-link>
	    </div>
			<!-- <el-skeleton :rows="10" :loading="isloading" animated > -->
	    <dl class="w50">
	      <dd>
	        <div id="slider-wrap">
						<ul id="slider">
							<el-carousel height="325px" style="width: 550px;" indicator-position="none" arrow="always" :loop="true">
								<el-carousel-item v-for="(item,index) in toutiaoLeftList.data" :key="item.id" v-if="index<2">
									<li>
										 <a @click="jumppush('/detail/'+item.id+'/1')" :title="item.title">
											 <!-- <img src="/images/sImg.png"/> -->
												 <img :src="toutiaoLeftList.images[item.id]" alt="" />
												 <span>{{item.title}}</span>
										 </a>                
									</li> 
								</el-carousel-item>
								<el-carousel-item v-for="(item,index) in toutiaoLeftList.data" :key="item.id" v-if="index<2">
									<li>
										 <a @click="jumppush('/detail/'+item.id+'/1')" :title="item.title">
											 <!-- <img src="/images/sImg.png"/> -->
												 <img :src="toutiaoLeftList.images[item.id]" alt="" />
												 <span>{{item.title}}</span>
										 </a>                
									</li> 
								</el-carousel-item>
							</el-carousel>
						</ul>
	          <!-- <ul id="slider">
	             <li>
	                <a href="detail.html">
	                    <img src="images/sImg.png"/>
	                    <span>全球首辆三轮飞行车获准试飞，飞行车将成未来新风口</span>
	                </a>                
	             </li>               
	             <li>
	              <a href="detail.html">
	                  <img src="images/sImg.png"/>
	                  <span>全球首辆三轮飞行车获准试飞，飞行车将成未来新风口</span>
	              </a>                
	           </li> 
	          </ul>
	          <div class="btns" id="next"><img src="images/sLeft.png"/></div>
	          <div class="btns" id="previous"><img src="images/sRight.png"/></div>  -->                 
	        </div>
	      </dd>
	      <dd>
	        <ul class="topLink">
						<li v-for="(item,index) in toutiaoRightList" :key="item.id" v-if="index>1"><a @click="jumppush('/detail/'+item.id+'/1')" :title="item.title">{{item.title}}</a></li>
	          <!-- <li><a href="detail.html">无人驾驶商业化运营已经按下“快进键”</a></li>
	          <li><a href="detail.html">华为Mate50将“正面刚iPhone14，芯片方案成各方</a></li>
	          <li><a href="detail.html">人形机器人概念热度空间，中国将成领跑者</a></li>
	          <li><a href="detail.html">拜登签署“芯片法案”，中企占半导体百强榜“半壁江</a></li>
	          <li><a href="detail.html">11家网约车平台被约谈，首提聚合平台“先行赔付”责</a></li> -->
	        </ul>
	      </dd>
	    </dl>
		<!-- </el-skeleton> -->
	  </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				toutiaoLeftList: [],
				toutiaoRightList: [],
			}
		},
		created:function(){
			this.toutiaoleftfnc();
			// this.toutiaorightfnc();
		},
		computed: {
	
		},
		methods: {
			trackClick:function(type){
				this.$track([
					['pagetype',type],
				]);
			},
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			toutiaoleftfnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'szjj/searchArticles',
						responseType: 'json',
						params: {
							columnID: '635e88fb59c94248b55a5836436cd99b',
							// isTopArticle: '1',
							iPage:'1',
							pageSize:'7',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.toutiaoLeftList = response.data.data.data;
						_this.toutiaoRightList = response.data.data.data.data;
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
			// toutiaorightfnc: function() {
			// 	let _this = this;
			// 	// this.resultDataList = {};
			// 	// this.totalResultCount = 0;
			// 	this.$http({
			// 			method: 'get',
			// 			url: 'selectArticlesByRecommendTagID',
			// 			responseType: 'json',
			// 			params: {
			// 				tagid: 'ecb509c8-bbd5-11ec-84ee-fefcfe218f7c',
			// 				istop: '0',
			// 			},
			// 		})
			// 		.then(function(response) {
			// 			// console.log(response);
			// 			// debugger;
			// 			_this.toutiaoRightList = response.data.data.data;
			// 		})
			// 		.catch(function(error) {
			// 			console.log(error);
			// 		});;
			// },
		}
	}
</script>

<style>
</style>
